import { render } from "./component-egrul-date-connect-loc-reestr.vue?vue&type=template&id=f130f6f8"
import script from "./component-egrul-date-connect-loc-reestr.vue?vue&type=script&setup=true&lang=js"
export * from "./component-egrul-date-connect-loc-reestr.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/counteragents/counteragent-version-card/components/component-egrul-date-connect-loc-reestr.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f130f6f8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f130f6f8', __exports__)) {
    api.reload('f130f6f8', __exports__)
  }
  
  module.hot.accept("./component-egrul-date-connect-loc-reestr.vue?vue&type=template&id=f130f6f8", () => {
    api.rerender('f130f6f8', render)
  })

}


export default __exports__